"use client";

import React from "react";
import { MiniNavBar } from "./MiniNavBar";
import { ExperimentFlags } from "@shared/utils.experimentation";

export const MiniNavBarWrapper: React.FC<{
  quizMiniNavExperimentValue: string | number | boolean;
}> = ({ quizMiniNavExperimentValue }) => {
  if (
    typeof quizMiniNavExperimentValue !== "number" ||
    quizMiniNavExperimentValue === -1
  ) {
    return null;
  }

  if (quizMiniNavExperimentValue === 0) {
    return (
      <div
        data-event-intersection="experimentViewed"
        data-flag={ExperimentFlags.PAGE_EXPERIMENT_QUIZ_MINI_NAV}
        data-variation={quizMiniNavExperimentValue}
      />
    );
  }

  return <MiniNavBar quizMiniNavExperimentValue={quizMiniNavExperimentValue} />;
};
